var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStars = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-public/img/sass-landing/icons/stars.svg__a)",
  fillRule: "evenodd",
  d: "M15.707 8.333c-.59 1.843-1.42 3.803-2.496 4.878-1.075 1.076-3.034 1.906-4.878 2.496a30.807 30.807 0 0 1-1.627.473c-.533.14-.533 1.11 0 1.251a36.388 36.388 0 0 1 1.627.473c1.844.59 3.803 1.42 4.878 2.496 1.076 1.075 1.906 3.034 2.496 4.878a31.445 31.445 0 0 1 .473 1.627c.14.533 1.11.533 1.251 0a36.087 36.087 0 0 1 .473-1.627c.59-1.844 1.42-3.803 2.496-4.878 1.075-1.076 3.035-1.906 4.878-2.496a30.178 30.178 0 0 1 1.627-.473c.533-.14.533-1.11 0-1.251a36.85 36.85 0 0 1-1.627-.473c-1.843-.59-3.803-1.42-4.878-2.496-1.076-1.075-1.906-3.035-2.496-4.878a30.742 30.742 0 0 1-.473-1.627c-.14-.533-1.11-.533-1.251 0a36.236 36.236 0 0 1-.473 1.627Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-public/img/sass-landing/icons/stars.svg__b)",
  d: "M6.112 1.069a.54.54 0 0 0-1.023 0L4.51 2.805A2.696 2.696 0 0 1 2.805 4.51l-1.736.578a.54.54 0 0 0 0 1.024l1.736.578c.805.269 1.437.9 1.705 1.705l.579 1.736a.54.54 0 0 0 1.023 0l.578-1.736c.269-.805.9-1.436 1.705-1.705l1.737-.578a.54.54 0 0 0 0-1.024L8.395 4.51A2.696 2.696 0 0 1 6.69 2.805l-.578-1.736Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/sass-landing/icons/stars.svg__a",
  x1: -3.024,
  x2: 27.305,
  y1: 14.002,
  y2: 0.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#07F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#07E5F9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-public/img/sass-landing/icons/stars.svg__b",
  x1: -3.024,
  x2: 27.305,
  y1: 14.002,
  y2: 0.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#07F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#07E5F9"
})))));
export { SvgStars as ReactComponent };